import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MaterialModule } from '../material/material.module';

export interface Tip {
  title: string;
  icon?: string;
  message: string;
  linkText?: string | null;
  routerlink?: string | null;
}

const TIPS: Tip[] = [
  {
    title: 'Cadastro concluído',
    icon: 'assets/icons/icon_nossosplanos.svg',
    message: 'Seu cadastro foi realizado com sucesso! Agora, escolha um perfil de acesso para começar a utilizar todos os exames e terapias disponíveis. Clique abaixo para conhecer os produtos e serviços que o Hub Medical oferece.',
    linkText: 'Ir para página de produtos',
    routerlink: 'shopping',
  },
  {
    title: 'Profissão adicionada com sucesso',
    icon: 'assets/icons/icon_certificados.svg',
    message: 'Sua profissão foi adicionada com sucesso! Lembre-se de que é necessário certificar sua profissão. Mas não esqueça de fazer o upload dos seus documentos comprobatórios e cadastrar os endereços onde você pode atuar.',
    linkText: null,
    routerlink: null,
  },
  {
    title: 'Negociação em andamento',
    icon: 'assets/icons/icon_certificados.svg',
    message: 'Você já tem uma negociação aberta com esse fornecedor. Acesse sua área de negociações para acompanhar suas conversas.',
    linkText: null,
    routerlink: null,
  },

];

@Component({
    selector: 'app-tips-dialog',
    standalone: true,
    templateUrl: './tips-dialog.component.html',
    styleUrls: ['./tips-dialog.component.scss'],
    imports: [MaterialModule]
})
export class TipsDialogComponent {
  tip: Tip | undefined;

  constructor(
    public dialogRef: MatDialogRef<TipsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { title: string }
  ) {
    this.tip = TIPS.find(t => t.title === data.title);

    if (!this.tip) {
      this.dialogRef.close()
    }
  }

  close(): void {
    this.dialogRef.close();
  }
}
